import Button from "components/base/Button";
import { Input } from "components/base/Form";
import formatShipmentProductName from "pages/sales/inventory/warehouses/shipments/formatShipmentProductName";
import { useContext } from "react";
import { BsTrash } from "react-icons/bs";
import BOMProductSelector from "./BOMProductSelector";
import CostPreview from "./CostPreview";
import { ProductContext } from "./ProductForm";

const BOMView = () => {
  const { product, setProduct } = useContext(ProductContext);

  const currency = product.company === "LTD" ? "RMB" : "USD";

  const children = product.children || [];
  const selectedChildren = children.filter((i) => i.product);

  console.log("product", product);

  return (
    <div className="card">
      <h5>BOM - Bill of Materials</h5>

      <div className="mt-4">
        <div className="flex items-center">
          <label>Qty / Set: </label>
          <Input
            className="ml-2 text-center w-20"
            value={product.itemsPerSet}
            onChange={(e) =>
              setProduct((prev) => ({ ...prev, itemsPerSet: e.target.value }))
            }
          />
        </div>

        <div className="mt-4">
          {children.map((child, index) => (
            <div
              key={index}
              className="py-1 flex justify-between items-center space-x-6"
            >
              <div className="flex flex-1 space-x-2 items-center">
                <Button
                  danger
                  onClick={() => {
                    setProduct((prev) => ({
                      ...prev,
                      children: prev.children.filter((_, i) => i !== index),
                    }));
                  }}
                >
                  <BsTrash />
                </Button>

                <BOMProductSelector
                  className="text-xs w-full"
                  company="AB"
                  autoFocus={child.shouldAutoFocus === true}
                  valueView={
                    child.product ? (
                      <div>
                        [{child.product.number}] {child.product.name}
                      </div>
                    ) : null
                  }
                  optionView={(product) => formatShipmentProductName(product)}
                  onSelect={(product) =>
                    setProduct((prev) => {
                      const newChildren = [...(prev.children || [])];
                      newChildren[index] = {
                        ...newChildren[index],
                        product,
                        shouldAutoFocus: false,
                      };
                      return { ...prev, children: newChildren };
                    })
                  }
                />
              </div>
              <div className="flex items-center space-x-2">
                <span className="text-xl">&times; </span>
                <Input
                  className="text-center w-24"
                  value={child.qty}
                  onChange={(e) =>
                    setProduct((prev) => {
                      const newChildren = [...(prev.children || [])];
                      newChildren[index] = {
                        ...newChildren[index],
                        qty: e.target.value,
                      };
                      return { ...prev, children: newChildren };
                    })
                  }
                />
              </div>
            </div>
          ))}
        </div>

        <Button
          className="mt-2"
          onClick={() =>
            setProduct((prev) => ({
              ...prev,
              children: [
                ...(prev.children || []).map((child) => ({
                  ...child,
                  shouldAutoFocus: false,
                })),
                { product: null, qty: 1, shouldAutoFocus: true },
              ],
            }))
          }
        >
          + Product
        </Button>

        {selectedChildren.length > 0 ? (
          <div className="relative flex space-x-4 items-center text-sm mt-4 pt-4 border-t border-gray-100 dark:border-gray-700">
            <label>Computed Cost:</label>
            <div className="font-bold relative">
              <CostPreview
                company={product.company}
                itemsPerSet={product.itemsPerSet}
                bom={selectedChildren}
                qty={product.defaultQty}
                currency={currency}
              />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default BOMView;
